module.exports = __webpack_public_path__ + "img/videoCover.fc9148a0.jpg";